export type ResultCategory = "win" | "loss" | "draw";

/**
 * Collapse a backend `result` string into one of three display categories.
 *
 * The backend already resolves every decisive chess.com game to "win" or
 * "loss" (the loser's side carries codes like "checkmated"/"resigned" while
 * the winner's is "win"). Draws never have "win" on either side, so they
 * arrive as the literal chess.com draw code — "agreed", "repetition",
 * "stalemate", "insufficient", "50move", "timevsinsufficient" — or, from
 * Lichess, "draw". Treating anything that isn't a win or loss as a draw means
 * a new draw code can't slip through as raw text.
 */
export function resultCategory(result: string): ResultCategory {
  if (result === "win") return "win";
  if (result === "loss") return "loss";
  return "draw";
}

const LABELS: Record<ResultCategory, string> = {
  win: "Win",
  loss: "Loss",
  draw: "Draw",
};

export function resultLabel(result: string): string {
  return LABELS[resultCategory(result)];
}
